import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonDatetime,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTextarea,
  IonTitle,
} from "@ionic/react";
import { trash } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Spacer from "../../../components/spacer";
import { getEntry, saveEntry } from "../../../services/users";
import EntryErrors from "./components/EntryErrors";
import FormBehaviours from "./FormBehaviours";
import FormNavigation from "./FormNavigation";
import FormResponses from "./FormResponses";

interface props {
  user: any;
  eid: any;
  dateTS: any;
}

const AddEditEntrySleep: React.FC<props> = ({ user, eid, dateTS }) => {
  const history = useHistory();

  const defaultDaySleep = {
    DSsetting: "",
    DStimeAsleep: "00:00",
    DStimeAwake: "00:00",
    DSother: "",
  };

  const defaultNightWakings = {
    NWtimeAwake: "00:00",
    NWduration: "",
  };

  const defaultState = {
    eid: "",
    date: "",
    page: 0,
    complete: false,
    unwell: false,
    medication: "",
    didDaySleep: false,
    numDaySleeps: 0,
    daySleeps: [],
    settingNight: "",
    otherNight: "",
    timeBed: "00:00",
    timeAsleep: "00:00",
    presentAtOnset: false,
    presentHours: 0,
    presentMins: 0,
    presentAllNight: false,
    curtainCalls: false,
    numCurtainCalls: 0,
    ccActivity: {
      activities: false,
      bed: false,
      book: false,
      electronics: false,
      fear: false,
      food: false,
      hid: false,
      other: false,
      parent: false,
      parentBed: false,
      physical: false,
      sibling: false,
      stereotypic: false,
      tantrum: false,
      toilet: false,
      toys: false,
      otherDescribe: "",
    },
    ccResponse: {
      allowed: false,
      breastfed: false,
      clothing: false,
      ignored: false,
      instructed: false,
      laydown: false,
      leftRoom: false,
      other: false,
      parentBed: false,
      physical: false,
      providedItems: false,
      removedFromBed: false,
      removedItems: false,
      reprimanded: false,
      returned: false,
      sat: false,
      siblingLeft: false,
      strategies: false,
      otherDescribe: "",
    },
    ccNotes: "",
    cosleep: false,
    cosleepLengthHours: "",
    cosleepLengthMins: "",
    didNightWakings: false,
    nightWakings: [],
    numNightWakings: 0,
    NWBehaviour: {
      activities: false,
      bed: false,
      book: false,
      electronics: false,
      fear: false,
      food: false,
      hid: false,
      other: false,
      parent: false,
      parentBed: false,
      physical: false,
      sibling: false,
      stereotypic: false,
      tantrum: false,
      toilet: false,
      toys: false,
      otherDescribe: "",
    },
    NWResponse: {
      allowed: false,
      breastfed: false,
      clothing: false,
      ignored: false,
      instructed: false,
      laydown: false,
      leftRoom: false,
      other: false,
      parentBed: false,
      physical: false,
      providedItems: false,
      removedFromBed: false,
      removedItems: false,
      reprimanded: false,
      returned: false,
      sat: false,
      siblingLeft: false,
      strategies: false,
      otherDescribe: "",
    },
    NWNotes: "",
    earlyWaking: false,
    EWBehaviour: {
      activities: false,
      bed: false,
      book: false,
      electronics: false,
      fear: false,
      food: false,
      hid: false,
      other: false,
      parent: false,
      parentBed: false,
      physical: false,
      sibling: false,
      stereotypic: false,
      tantrum: false,
      toilet: false,
      toys: false,
      otherDescribe: "",
    },
    EWResponse: {
      allowed: false,
      breastfed: false,
      clothing: false,
      ignored: false,
      instructed: false,
      laydown: false,
      leftRoom: false,
      other: false,
      parentBed: false,
      physical: false,
      providedItems: false,
      removedFromBed: false,
      removedItems: false,
      reprimanded: false,
      returned: false,
      sat: false,
      siblingLeft: false,
      strategies: false,
      otherDescribe: "",
    },
    EWNotes: "",
    MWTime: "00:00",
    additionalNotes: "",
  };

  //const [user, setUser] = useState<any>({});
  const [entry, setEntry] = useState<any>(defaultState);
  const [dates, setDates] = useState<any>([]);
  const [formErrors, setFormErrors] = useState<any>([]);
  const [setupComplete, setSetupComplete] = useState<any>(false);
  // const [entryRetrieved, setEntryRetrieved] = useState<any>(false);

  // const setEntry = (state: any) => {
  // 	console.log(daySleeps);
  // 	console.log(state);
  // 	console.trace();
  // 	setTheEntry(state);
  // };

  const {
    date,
    page,
    complete,
    unwell,
    medication,
    didDaySleep,
    numDaySleeps,
    daySleeps,
    settingNight,
    otherNight,
    timeBed,
    timeAsleep,
    presentAtOnset,
    presentHours,
    presentMins,
    presentAllNight,
    curtainCalls,
    numCurtainCalls,
    ccActivity,
    ccResponse,
    ccNotes,
    cosleep,
    cosleepLengthHours,
    cosleepLengthMins,
    nightWakings,
    didNightWakings,
    numNightWakings,
    NWBehaviour,
    NWResponse,
    NWNotes,
    earlyWaking,
    EWBehaviour,
    EWResponse,
    EWNotes,
    MWTime,
    additionalNotes,
  } = entry;

  const _onChange = (e: any) => {
    if (setupComplete) {
      let name = e.target.name;
      let value = e.target.value;

      console.log(name, value);
      //   console.log(numNightWakings);
      //   console.log(nightWakings);

      if (["DStimeAsleep", "DStimeAwake", "DSother"].includes(name)) {
        //let fieldID = e.target.id;
        //alert(fieldID);
        let id = e.target.dataset.id;
        //alert(id);
        let DS: any = daySleeps;
        //console.log(daySleeps);
        //alert(JSON.stringify(DS));
        //let sleep = DS[id];
        //alert(JSON.stringify(sleep));
        //let res = { [name]: value };
        //console.log(id);

        DS[id][name] = value;
        // DS.splice
        // DS.splice(id, 0, sleep);
        // alert(JSON.stringify(DS));
        //	console.log(name, id, value);
        //console.log(DS);
        // let result = daySleeps;
        // console.log([...daySleeps, [id]:res]);

        // let outputString = "";
        // DS.forEach((el: any) => {
        // 	console.log(el.DStimeAwake);
        // 	if (outputString === "") {
        // 		outputString = el.DStimeAwake;
        // 	} else outputString = outputString.concat(", ", el.DStimeAwake);
        // });
        // console.log(outputString);
        // alert(outputString);
        //alert(`IDX:${id}, Value:${value}`);

        setEntry({ ...entry, daySleeps: [...DS] });
      } else if (["NWtimeAwake", "NWduration"].includes(name)) {
        let id = e.target.dataset.id;
        let NW = entry.nightWakings;
        NW[id][name] = value;
        //setEntry({ ...entry, nightWakings: NW });
      } else if (
        [
          "ccActivity",
          "ccResponse",
          "NWBehaviour",
          "NWResponse",
          "EWBehaviour",
          "EWResponse",
        ].includes(e.target.dataset.id)
      ) {
        let field = e.target.dataset.id;
        let activity = entry[field];
        let checked = e.target.checked;
        console.log(field, activity, name, value);
        if (name !== "otherDescribe") {
          activity[name] = checked;
        } else {
          activity[name] = value;
        }
        console.log(activity);
        setEntry({ ...entry, [field]: activity });
      } else if (name === "didDaySleep" && value === false) {
        setEntry({
          ...entry,
          didDaySleep: false,
          numDaySleeps: 0,
          daySleeps: [],
        });
      } else if (name === "numDaySleeps" && value === 0) {
        setEntry({ ...entry, numDaySleeps: value, daySleeps: [] });
      } else if (name === "presentAtOnset" && value === false) {
        setEntry({
          ...entry,
          presentAtOnset: false,
          presentAllNight: false,
          presentHours: 0,
          presentMins: 0,
        });
      } else if (name === "presentAllNight" && value === true) {
        setEntry({
          ...entry,
          presentAllNight: value,
          presentHours: 0,
          presentMins: 0,
        });
      } else if (name === "curtainCalls" && value === false) {
        let behaviours = ccActivity;
        Object.entries(behaviours).forEach((obj: any) => {
          behaviours[obj[0]] = false;
        });
        let responses = ccResponse;
        Object.entries(responses).forEach((obj: any) => {
          responses[obj[0]] = false;
        });
        setEntry({
          ...entry,
          curtainCalls: false,
          numCurtainCalls: 0,
          ccActivity: behaviours,
          ccResponse: responses,
        });
      } else if (name === "cosleep" && value === false) {
        setEntry({
          ...entry,
          cosleep: false,
          cosleepLengthHours: "",
          cosleepLengthMins: "",
        });
      } else if (name === "didNightWakings" && value === false) {
        setEntry({
          ...entry,
          didNightWakings: false,
          numNightWakings: 0,
          nightWakings: [],
        });
      } else if (name === "didNightWakings" && value === true) {
        setEntry({
          ...entry,
          didNightWakings: true,
          numNightWakings: 1,
          nightWakings: [defaultNightWakings],
        });
      } else if (name === "numNightWakings" && parseInt(value) === 0) {
        setEntry({ ...entry, numNightWakings: value, nightWakings: [] });
      } else if (name === "nightWakings" && value === false) {
        let behaviours = NWBehaviour;
        Object.entries(behaviours).forEach((obj: any) => {
          behaviours[obj[0]] = false;
        });
        let responses = NWResponse;
        Object.entries(responses).forEach((obj: any) => {
          responses[obj[0]] = false;
        });
        setEntry({
          ...entry,
          nightWakings: false,
          numNightWakings: 0,
          NWBehaviour: behaviours,
          NWResponse: responses,
        });
      } else if (name === "earlyWaking" && value === false) {
        let behaviours = EWBehaviour;
        Object.entries(behaviours).forEach((obj: any) => {
          behaviours[obj[0]] = false;
        });
        let responses = EWResponse;
        Object.entries(responses).forEach((obj: any) => {
          responses[obj[0]] = false;
        });
        setEntry({
          ...entry,
          earlyWaking: false,
          EWBehaviour: behaviours,
          EWResponse: responses,
        });
      } else {
        // let intVal = parseInt(value);
        // console.log(intVal);
        // if (name === "numDaySleeps") {
        // 	if (intVal < 0) value = 0;
        // 	if (intVal > 10) value = 10;
        // }
        // if (name === "numNightWakings") {
        // 	if (intVal < 0) value = 0;
        // 	if (intVal > 10) value = 10;
        // }
        //console.log(name, value);
        setEntry({ ...entry, [name]: value });
      }
    }
  };

  const _onSubmit = () => {
    let stepValid = _checkValid(page);
    if (stepValid) {
      _saveEntry({ ...entry, complete: true });
      history.push(`/users/${user.id}`);
    }
  };

  const _saveEntry = (data: any) => {
    saveEntry(user.id, data);
  };

  useEffect(() => {
    if (!user.id && user.uid) user.id = user.uid;
    if (user && user.id) {
      if (eid) {
        getEntry(user.id, eid).then((doc) => {
          setEntry({
            ...defaultState,
            ...doc,
            date: doc?.date || getDate(),
          });
          setSetupComplete(true);
        });
      }
      if (user.dates && Object.values(dates).length < 1) {
        getUserDates();
      }
    }
  }, [user, eid]);

  useEffect(() => {
    if (dates && entry.date === "") {
      let today = new Date().getTime();
      let date = getDate();
      if (date) {
        setEntry({ ...entry, eid: today.toString(), dateTS, date: date });
      }

      setSetupComplete(true);
    }
  }, [dates]);

  //   useEffect(() => {
  //     console.log(entry.date);
  //     console.log(entry);
  //     console.log(user);
  //   }, [entry]);

  // useEffect(() => {
  // 	let daySleepArray = daySleeps;
  // 	let numSleeps = parseInt(numDaySleeps);

  // 	if (numSleeps > 0 && numSleeps !== Object.values(daySleepArray).length) {
  // 		//console.log("we're in here");
  // 		if (numSleeps < Object.values(daySleepArray).length) {
  // 			while (numSleeps < Object.values(daySleepArray).length) {
  // 				daySleepArray.pop();
  // 			}
  // 		} else if (numSleeps > Object.values(daySleepArray).length) {
  // 			while (numSleeps > Object.values(daySleepArray).length) {
  // 				daySleepArray.push(defaultDaySleep);
  // 			}
  // 		}
  // 		setEntry({ ...entry, daySleeps: daySleepArray });
  // 	}

  // 	// console.log(daySleepArray);
  // }, [numDaySleeps]);

  // useEffect(() => {
  // 	let NWArray = nightWakings;
  // 	let numWakings = parseInt(numNightWakings);

  // 	if (numWakings > 0 && numWakings !== Object.values(NWArray).length) {
  // 		//console.log("we're in here");
  // 		if (numWakings < Object.values(NWArray).length) {
  // 			while (numWakings < Object.values(NWArray).length) {
  // 				NWArray.pop();
  // 			}
  // 		} else if (numWakings > Object.values(NWArray).length) {
  // 			while (numWakings > Object.values(NWArray).length) {
  // 				NWArray.push(defaultNightWakings);
  // 			}
  // 		}
  // 		setEntry({ ...entry, nightWakings: NWArray });
  // 	}

  // 	// console.log(daySleepArray);
  // }, [numNightWakings]);

  /**
   * Create an array of objects which represent dates within phases and whether an entry is required
   */
  const getUserDates = () => {
    let response: any = [];
    let today = new Date().getTime();

    Object.values(user.dates).forEach((element: any) => {
      let status = "upcoming";
      let link = "upcoming";
      let date = element.timestamp;

      //Add another condition here to check if an entry exists for the date and add a link
      if (date <= today) {
        status = "overdue";
        link = "new";
      }

      response[date] = {
        ...element,
        status,
        link,
      };
    });
    setDates(response);
  };

  const getDate = () => {
    let res = "";
    //debugger;
    if (dates[dateTS]) {
      let date = dates[dateTS];
      res = date.dateField;
    }
    //console.log(res);
    return res;
  };

  const _compareDSSetting = (o1: any, o2: any, idx: any) => {
    // console.log(idx);
    // console.log(daySleeps[idx]["DSsetting"]);
    if (daySleeps[idx]) return o1 === daySleeps[idx]["DSsetting"];
    else return false;
  };

  const _compareSettingNight = (o1: any, o2: any) => {
    return o1 === settingNight;
  };

  const _onSelect = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let id = e.target.dataset.id;

    let DS = daySleeps;

    if (name === "DSsetting") {
      DS[id]["DSsetting"] = value;
      if (value !== "other") {
        DS[id]["DSother"] = "";
      }
      setEntry({ ...entry, daySleeps: DS });
    } else if (name === "settingNight") {
      if (value !== "other")
        setEntry({ ...entry, settingNight: value, otherNight: "" });
      else setEntry({ ...entry, settingNight: value });
    }
  };

  const _checkValid = (page: any) => {
    let errors = [];
    switch (page) {
      case 0:
        //no checks required
        break;
      case 1: //Day sleeps
        if (didDaySleep === true && numDaySleeps === 0)
          errors.push(
            "Number of sleeps can not be 0 as you have indicated that the child did sleep"
          );
        let sessionErrors = false;
        Object.values(daySleeps).forEach((session: any) => {
          if (
            session.DSsetting === "" ||
            session.DStimeAsleep === "" ||
            session.DStimeAwake === ""
          ) {
            sessionErrors = true;
          }
          if (session.DSsetting === "other" && session.DSother === "")
            sessionErrors = true;
        });
        if (sessionErrors) errors.push("Please check sleep session details");
        break;
      case 2: //Night time sleeps
        if (settingNight === "") errors.push("Setting is required");
        if (timeBed === "") errors.push("Time to bed is required");
        if (timeAsleep === "") errors.push("Time asleep is required");
        if (
          presentAtOnset &&
          !presentAllNight &&
          ((presentHours === "0" && presentMins === "0") ||
            (presentHours === 0 && presentMins === 0))
        )
          errors.push("Please specify time you were present");
        if (settingNight === "other" && otherNight === "")
          errors.push("Please specify sleep setting");
        break;
      case 3: //Curtain calls
        if (
          curtainCalls === true &&
          (numCurtainCalls === 0 || numCurtainCalls === "0")
        )
          errors.push(
            "Number of curtain calls can not be 0 as you have indicated that the child did make curtain calls"
          );
        let ccBehaviours = Object.values(ccActivity).filter(
          (element: any) => element === true
        );
        let ccResponses = Object.values(ccResponse).filter(
          (element: any) => element === true
        );
        if (
          curtainCalls === true &&
          (ccBehaviours.length === 0 || ccResponses.length === 0)
        )
          errors.push(
            "Please check boxes beside the appropriate behaviours and responses"
          );
        break;
      case 4: //co-sleeping
        if (
          cosleep &&
          ((cosleepLengthHours === "0" && cosleepLengthMins === "0") ||
            (cosleepLengthHours === "" && cosleepLengthMins === ""))
        )
          errors.push("Co-sleep length can not be 0 or left empty");
        break;
      case 5: //Night wakings
        if (
          didNightWakings === true &&
          (numNightWakings === 0 || numNightWakings === "0")
        )
          errors.push(
            "Number of night wakings can not be 0 as you have indicated that the child did wake"
          );

        let NWsessionErrors = false;
        Object.values(nightWakings).forEach((session: any) => {
          if (session.NWtimeAwake === "" || session.NWduration === "") {
            NWsessionErrors = true;
          }
        });
        if (NWsessionErrors) errors.push("Please check waking session details");

        let NWbehaviours = Object.values(NWBehaviour).filter(
          (element: any) => element === true
        );
        let NWresponses = Object.values(NWResponse).filter(
          (element: any) => element === true
        );
        if (
          didNightWakings === true &&
          (NWbehaviours.length === 0 || NWresponses.length === 0)
        )
          errors.push(
            "Please check boxes beside the appropriate behaviours and responses"
          );

        break;
      case 6: //Early wakings
        let EWBehaviours = Object.values(EWBehaviour).filter(
          (element: any) => element === true
        );
        let EWResponses = Object.values(EWResponse).filter(
          (element: any) => element === true
        );
        if (
          earlyWaking === true &&
          (EWBehaviours.length === 0 || EWResponses.length === 0)
        )
          errors.push(
            "Please check boxes beside the appropriate behaviours and responses"
          );
        break;
      case 7: //Early wakings
        if (MWTime === "") errors.push("Morning wake");
        break;
      default:
        break;
    }
    setFormErrors(errors);

    return Object.values(errors).length === 0;
  };

  const changePage = (toPage: any) => {
    //console.log(formErrors);

    if (toPage > page) {
      let stepValid = _checkValid(page);

      if (stepValid) {
        setEntry({ ...entry, page: toPage });
        _saveEntry({ ...entry, page: toPage });
      }
    } else {
      setFormErrors([]);
      setEntry({ ...entry, page: toPage });
      //_saveEntry({ ...entry, page: toPage });
    }
  };

  const _addDaysleep = (e: any) => {
    let DS = daySleeps;
    let length = DS.length;
    if (length < 6) {
      DS.push(defaultDaySleep);
      setEntry({ ...entry, numDaySleeps: DS.length, daySleeps: DS });
    }
  };

  const _removeDaysleep = (i: number) => {
    let DS = daySleeps;
    DS.splice(i, 1);
    setEntry({ ...entry, numDaySleeps: DS.length, daySleeps: DS });
  };

  const _addNightWaking = (e: any) => {
    let NW = nightWakings;
    let length = NW.length;
    if (length < 10) {
      NW.push(defaultNightWakings);
      setEntry({ ...entry, numNightWakings: NW.length, nightWakings: NW });
    }
  };

  const _removeNightWaking = (i: number) => {
    let NW = nightWakings;
    NW.splice(i, 1);
    setEntry({ ...entry, numNightWakings: NW.length, nightWakings: NW });
  };

  return (
    <>
      {setupComplete && (
        <>
          {eid && dates && dates[eid] && (
            <h1>Entry for {dates[eid].dateString}</h1>
          )}

          {eid && user.dates && (
            <IonInput
              name="date"
              value={date}
              type="date"
              hidden
              onIonChange={_onChange}
            />
          )}

          <FormNavigation
            page={page}
            setPage={changePage}
            onSubmit={_onSubmit}
            numPages={8}
          />
          <EntryErrors errors={formErrors} />
          <Spacer size="60" />
          {page === 0 && (
            <>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">
                    Was your child unwell on this day?
                  </IonLabel>
                  <Spacer size="10" />
                  <IonRadioGroup
                    value={unwell}
                    onIonChange={_onChange}
                    name="unwell"
                    id="unwell"
                  >
                    <IonItem lines="none">
                      <IonLabel>Yes, my child was unwell</IonLabel>
                      <IonRadio slot="start" value={true}></IonRadio>
                    </IonItem>
                    <IonItem lines="none">
                      <IonLabel>No, they were not unwell</IonLabel>
                      <IonRadio slot="start" value={false}></IonRadio>
                    </IonItem>
                  </IonRadioGroup>
                </IonItem>
                <Spacer size="30" />
                <IonItem>
                  <IonLabel position="stacked">Medication</IonLabel>
                  <p>
                    If your child was provided with medication to support their
                    sleep and they are not given this on a nightly basis, please
                    record below
                  </p>
                  <IonTextarea
                    name="medication"
                    value={medication}
                    onIonChange={_onChange}
                  />
                </IonItem>
              </IonList>
            </>
          )}
          {page === 1 && (
            <>
              <IonTitle>Day Sleep</IonTitle>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">
                    Did your child sleep during the day?
                  </IonLabel>
                  <Spacer size="10" />
                  <IonRadioGroup
                    value={didDaySleep}
                    onIonChange={_onChange}
                    name="didDaySleep"
                    id="didDaySleep"
                  >
                    <IonItem lines="none">
                      <IonLabel>Yes</IonLabel>
                      <IonRadio slot="start" value={true}></IonRadio>
                    </IonItem>
                    <IonItem lines="none">
                      <IonLabel>No</IonLabel>
                      <IonRadio slot="start" value={false}></IonRadio>
                    </IonItem>
                  </IonRadioGroup>
                </IonItem>
                <Spacer size="30" />
                {didDaySleep &&
                  daySleeps.map((sleep: any, DSidx: any) => {
                    //console.log(idx);
                    let DSSettingID = `DSSetting-${DSidx}`,
                      DStimeAsleepID = `DStimeAsleep-${DSidx}`,
                      DStimeAwakeID = `DStimeAwake-${DSidx}`,
                      DSotherID = `DSother-${DSidx}`;
                    return (
                      <div key={DSidx}>
                        <IonCard className="repeater-card">
                          <IonCardHeader>
                            <IonItem lines="none">
                              <IonCardTitle>
                                {`Day Sleep ${DSidx + 1}`}
                              </IonCardTitle>

                              <IonIcon
                                slot="end"
                                onClick={() => _removeDaysleep(DSidx)}
                                icon={trash}
                                className="trash linked"
                              />
                            </IonItem>
                          </IonCardHeader>
                          <IonCardContent>
                            <IonItem>
                              <IonLabel position="stacked">Setting</IonLabel>
                              <IonSelect
                                compareWith={(currentValue, compareValue) =>
                                  _compareDSSetting(
                                    currentValue,
                                    compareValue,
                                    DSidx
                                  )
                                }
                                id={DSSettingID}
                                data-id={DSidx}
                                name="DSsetting"
                                value={sleep.DSsetting}
                                onIonChange={_onSelect}
                                okText="Okay"
                                cancelText="Dismiss"
                                placeholder="Select One"
                                interface="popover"
                              >
                                <IonSelectOption value="childs">
                                  Child's bed
                                </IonSelectOption>
                                <IonSelectOption value="parents">
                                  Parent's bed
                                </IonSelectOption>
                                <IonSelectOption value="car">
                                  Car
                                </IonSelectOption>
                                <IonSelectOption value="living">
                                  Living/Family room
                                </IonSelectOption>
                                <IonSelectOption value="school">
                                  Preschool or school
                                </IonSelectOption>
                                <IonSelectOption value="other">
                                  Other
                                </IonSelectOption>
                              </IonSelect>
                            </IonItem>

                            {sleep.DSsetting === "other" && (
                              <IonItem>
                                <IonLabel position="stacked">
                                  Please describe setting
                                </IonLabel>
                                <IonInput
                                  id={DSotherID}
                                  name="DSother"
                                  data-id={DSidx}
                                  value={sleep.DSother}
                                  onIonChange={_onChange}
                                />
                              </IonItem>
                            )}

                            <IonItem>
                              <IonLabel position="stacked">
                                Time Asleep
                              </IonLabel>
                              <IonInput
                                id={DStimeAsleepID}
                                name="DStimeAsleep"
                                value={sleep.DStimeAsleep}
                                data-id={DSidx}
                                type="time"
                                onIonChange={_onChange}
                              />
                            </IonItem>
                            <IonItem>
                              <IonLabel position="stacked">Time Awake</IonLabel>
                              <IonInput
                                id={DStimeAwakeID}
                                name="DStimeAwake"
                                value={sleep.DStimeAwake}
                                data-id={DSidx}
                                type="time"
                                onIonChange={_onChange}
                              />
                            </IonItem>
                            {sleep.pError && (
                              <IonItem lines="none">
                                <p className="error">{sleep.pError}</p>
                              </IonItem>
                            )}
                          </IonCardContent>
                        </IonCard>
                      </div>
                    );
                  })}
                {didDaySleep && (
                  <IonItem lines="none">
                    <IonButton size="default" onClick={_addDaysleep}>
                      Add Day Sleep
                    </IonButton>
                  </IonItem>
                )}
              </IonList>
            </>
          )}
          {page === 2 && (
            <>
              <IonTitle>Night-time Sleep</IonTitle>
              <IonList>
                <IonItem>
                  <IonLabel position="stacked">Setting</IonLabel>
                  <IonSelect
                    compareWith={_compareSettingNight}
                    id="settingNight"
                    name="settingNight"
                    value={settingNight}
                    onIonChange={_onSelect}
                    okText="Okay"
                    cancelText="Dismiss"
                    placeholder="Select One"
                    interface="popover"
                  >
                    <IonSelectOption value="childs">
                      Child's bed
                    </IonSelectOption>
                    <IonSelectOption value="parents">
                      Parent's bed
                    </IonSelectOption>
                    <IonSelectOption value="car">Car</IonSelectOption>
                    <IonSelectOption value="living">
                      Living/Family room
                    </IonSelectOption>
                    <IonSelectOption value="school">
                      Preschool or school
                    </IonSelectOption>
                    <IonSelectOption value="other">Other</IonSelectOption>
                  </IonSelect>
                </IonItem>

                {settingNight === "other" && (
                  <>
                    <Spacer size="30" />
                    <IonItem>
                      <IonLabel position="stacked">
                        Please describe other
                      </IonLabel>
                      <IonInput
                        id="otherNight"
                        name="otherNight"
                        value={otherNight}
                        onIonChange={_onChange}
                      />
                    </IonItem>
                  </>
                )}
                <Spacer size="30" />
                <IonItem>
                  <IonLabel position="stacked">Time put to bed</IonLabel>
                  <IonInput
                    name="timeBed"
                    value={timeBed}
                    type="time"
                    // hidden
                    onIonChange={_onChange}
                  />
                </IonItem>
                <Spacer size="30" />
                <IonItem>
                  <IonLabel position="stacked">
                    Time your child fell asleep
                  </IonLabel>
                  <IonInput
                    name="timeAsleep"
                    value={timeAsleep}
                    type="time"
                    // hidden
                    onIonChange={_onChange}
                  />
                </IonItem>
                <Spacer size="30" />
                <IonItem lines="none">
                  <IonLabel position="stacked">
                    Were you present during initial sleep onset?
                  </IonLabel>
                  <Spacer size="10" />
                  <IonRadioGroup
                    value={presentAtOnset}
                    onIonChange={_onChange}
                    name="presentAtOnset"
                    id="presentAtOnset"
                  >
                    <IonItem lines="none">
                      <IonLabel>Yes</IonLabel>
                      <IonRadio slot="start" value={true}></IonRadio>
                    </IonItem>
                    <IonItem lines="none">
                      <IonLabel>No</IonLabel>
                      <IonRadio slot="start" value={false}></IonRadio>
                    </IonItem>
                  </IonRadioGroup>
                </IonItem>
                {presentAtOnset === true && (
                  <>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        Were you present all night?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        value={presentAllNight}
                        onIonChange={_onChange}
                        name="presentAllNight"
                        id="presentAllNight"
                      >
                        <IonItem lines="none">
                          <IonLabel>Yes</IonLabel>
                          <IonRadio slot="start" value={true}></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>No</IonLabel>
                          <IonRadio slot="start" value={false}></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                    {presentAllNight === false && (
                      <>
                        <Spacer size="30" />
                        <IonItem lines="none">
                          <IonLabel position="stacked">
                            How long were you present for?
                          </IonLabel>
                          <Spacer size="10" />
                        </IonItem>
                        <Spacer size="10" />
                        <IonGrid>
                          <IonRow>
                            <IonCol>
                              <IonItem>
                                <IonLabel position="stacked">Hours</IonLabel>
                                <IonInput
                                  id="presentHours"
                                  name="presentHours"
                                  value={presentHours}
                                  onIonChange={_onChange}
                                  type="number"
                                />
                              </IonItem>
                            </IonCol>
                            <IonCol>
                              <IonItem>
                                <IonLabel position="stacked">Minutes</IonLabel>
                                <IonInput
                                  id="presentMins"
                                  name="presentMins"
                                  value={presentMins}
                                  onIonChange={_onChange}
                                  type="number"
                                />
                              </IonItem>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </>
                    )}
                  </>
                )}
              </IonList>
            </>
          )}
          {page === 3 && (
            <>
              <IonTitle>Curtain Calls</IonTitle>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">
                    Were there curtain calls or sleep interfering behaviours
                    after your child was put to bed?
                  </IonLabel>
                  <Spacer size="15" />
                  <IonNote>(i.e., attempts to get your attention)</IonNote>
                  <Spacer size="10" />
                  <IonRadioGroup
                    value={curtainCalls}
                    onIonChange={_onChange}
                    name="curtainCalls"
                    id="curtainCalls"
                  >
                    <IonItem lines="none">
                      <IonLabel>Yes</IonLabel>
                      <IonRadio slot="start" value={true}></IonRadio>
                    </IonItem>
                    <IonItem lines="none">
                      <IonLabel>No</IonLabel>
                      <IonRadio slot="start" value={false}></IonRadio>
                    </IonItem>
                  </IonRadioGroup>
                </IonItem>
                {curtainCalls && (
                  <>
                    <Spacer size="30" />
                    <IonItem>
                      <IonLabel position="floating">
                        Number of curtain calls?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>
                        Note: Do not count each individual call for attention
                        that might happen within a few seconds of each other.
                        Only count the curtain calls that happen when there is
                        at least a few minutes of quiet time in between.
                      </IonNote>
                      <Spacer size="10" />
                      <IonInput
                        id="numCurtainCalls"
                        name="numCurtainCalls"
                        value={numCurtainCalls}
                        onIonChange={_onChange}
                        type="number"
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        What did your child do during the curtain call(s)?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>
                        Note: Tick as many boxes as required to cover all of
                        your child's behaviours during the night's curtain
                        call(s)
                      </IonNote>
                      <FormBehaviours
                        field={ccActivity}
                        fieldName={"ccActivity"}
                        onChange={_onChange}
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        What were your responses to the curtain call(s)?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>
                        Note: Tick as many boxes as required to cover all of
                        your responses during the night's curtain call(s)
                      </IonNote>
                      <FormResponses
                        field={ccResponse}
                        fieldName={"ccResponse"}
                        onChange={_onChange}
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem>
                      <IonLabel position="stacked">Notes</IonLabel>
                      <IonTextarea
                        id="ccNotes"
                        name="ccNotes"
                        value={ccNotes}
                        onIonChange={_onChange}
                      />
                    </IonItem>
                  </>
                )}

                <Spacer size="30" />
              </IonList>
            </>
          )}
          {page === 4 && (
            <>
              <IonTitle>Co-Sleeping</IonTitle>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">Did you co-sleep?</IonLabel>
                  <Spacer size="10" />
                  <IonNote>
                    i.e., child in your bedroom, or you in child's bedroom
                  </IonNote>

                  <IonRadioGroup
                    value={cosleep}
                    onIonChange={_onChange}
                    name="cosleep"
                    id="cosleep"
                  >
                    <IonItem lines="none">
                      <IonLabel>Yes</IonLabel>
                      <IonRadio slot="start" value={true}></IonRadio>
                    </IonItem>
                    <IonItem lines="none">
                      <IonLabel>No</IonLabel>
                      <IonRadio slot="start" value={false}></IonRadio>
                    </IonItem>
                  </IonRadioGroup>
                </IonItem>
                {cosleep === true && (
                  <>
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        How long did you co-sleep?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>Duration of co-sleeping</IonNote>
                    </IonItem>
                    <Spacer size="10" />
                    <IonGrid>
                      <IonRow>
                        <IonCol>
                          <IonItem>
                            <IonLabel position="stacked">Hours</IonLabel>
                            <IonInput
                              id="cosleepLengthHours"
                              name="cosleepLengthHours"
                              value={cosleepLengthHours}
                              onIonChange={_onChange}
                              type="number"
                            />
                          </IonItem>
                        </IonCol>
                        <IonCol>
                          <IonItem>
                            <IonLabel position="stacked">Minutes</IonLabel>
                            <IonInput
                              id="cosleepLengthMins"
                              name="cosleepLengthMins"
                              value={cosleepLengthMins}
                              onIonChange={_onChange}
                              type="number"
                            />
                          </IonItem>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </>
                )}
              </IonList>
            </>
          )}
          {page === 5 && (
            <>
              <IonTitle>Night Wakings</IonTitle>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">
                    Did your child wake up in the night after falling asleep?
                  </IonLabel>
                  <Spacer size="10" />
                  <IonRadioGroup
                    value={didNightWakings}
                    onIonChange={_onChange}
                    name="didNightWakings"
                    id="didNightWakings"
                  >
                    <IonItem lines="none">
                      <IonLabel>Yes</IonLabel>
                      <IonRadio slot="start" value={true}></IonRadio>
                    </IonItem>
                    <IonItem lines="none">
                      <IonLabel>No</IonLabel>
                      <IonRadio slot="start" value={false}></IonRadio>
                    </IonItem>
                  </IonRadioGroup>
                </IonItem>
                <Spacer size="30" />
                {didNightWakings &&
                  Object.values(nightWakings).map((sleep: any, idx: any) => {
                    let NWtimeAwakeID = `NWtimeAwake-${idx}`,
                      NWdurationID = `NWduration-${idx}`;
                    return (
                      <div key={idx}>
                        <IonCard className="repeater-card">
                          <IonCardHeader>
                            <IonItem lines="none">
                              <IonCardTitle>
                                {`Night Waking ${idx + 1}`}
                              </IonCardTitle>
                              <IonIcon
                                slot="end"
                                onClick={() => _removeNightWaking(idx)}
                                icon={trash}
                                className="trash linked"
                              />
                            </IonItem>
                          </IonCardHeader>
                          <IonCardContent>
                            <IonItem>
                              <IonLabel position="stacked">
                                What time did your child wake?
                              </IonLabel>
                              <IonInput
                                id={NWtimeAwakeID}
                                name="NWtimeAwake"
                                value={nightWakings[idx].NWtimeAwake}
                                data-id={idx}
                                type="time"
                                onIonChange={_onChange}
                              />
                            </IonItem>

                            <IonItem>
                              <IonLabel position="stacked">
                                Duration of time awake (in minutes)
                              </IonLabel>
                              <IonInput
                                id={NWdurationID}
                                name="NWduration"
                                value={nightWakings[idx].NWduration}
                                data-id={idx}
                                type="number"
                                onIonChange={_onChange}
                              />
                            </IonItem>
                            {nightWakings[idx].pError && (
                              <IonItem className="no-padding" lines="none">
                                <p className="error">
                                  {nightWakings[idx].pError}
                                </p>
                              </IonItem>
                            )}
                          </IonCardContent>
                        </IonCard>
                      </div>
                    );
                  })}
                {didNightWakings && (
                  <IonItem lines="none">
                    <IonButton size="default" onClick={_addNightWaking}>
                      Add Night Waking
                    </IonButton>
                  </IonItem>
                )}
                {didNightWakings && (
                  <>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        What were your child's behaviours during the night
                        waking(s)?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>
                        Note: tick as many boxes as required to cover all of
                        your child's behaviours during the night waking(s).
                      </IonNote>
                      <FormBehaviours
                        field={NWBehaviour}
                        fieldName={"NWBehaviour"}
                        onChange={_onChange}
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        What were your responses to the curtain call(s)?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>
                        Note: Tick as many boxes as required to cover all of
                        your responses during the night's curtain call(s)
                      </IonNote>
                      <FormResponses
                        field={NWResponse}
                        fieldName={"NWResponse"}
                        onChange={_onChange}
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem>
                      <IonLabel position="stacked">Notes</IonLabel>
                      <IonTextarea
                        id="NWNotes"
                        name="NWNotes"
                        value={NWNotes}
                        onIonChange={_onChange}
                      />
                    </IonItem>
                  </>
                )}

                <Spacer size="30" />
              </IonList>
            </>
          )}
          {page === 6 && (
            <>
              <IonTitle>Early Waking</IonTitle>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">
                    Did your child wake early in the morning (i.e., before 6am)
                    and not go back to sleep?
                  </IonLabel>
                  <Spacer size="10" />
                  <IonRadioGroup
                    value={earlyWaking}
                    onIonChange={_onChange}
                    name="earlyWaking"
                    id="earlyWaking"
                  >
                    <IonItem lines="none">
                      <IonLabel>Yes (Woke before 6am)</IonLabel>
                      <IonRadio slot="start" value={true}></IonRadio>
                    </IonItem>
                    <IonItem lines="none">
                      <IonLabel>No</IonLabel>
                      <IonRadio slot="start" value={false}></IonRadio>
                    </IonItem>
                  </IonRadioGroup>
                </IonItem>
                {earlyWaking && (
                  <>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        What were your child's behaviours after the early
                        waking?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>
                        Note: tick as many boxes as required to cover all of
                        your child's behaviours after the early waking.
                      </IonNote>
                      <FormBehaviours
                        field={EWBehaviour}
                        fieldName={"EWBehaviour"}
                        onChange={_onChange}
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        What were your responses after the early waking?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonNote>
                        Note: tick as many boxes as required to cover all of
                        your responses after the early waking.
                      </IonNote>
                      <FormResponses
                        field={EWResponse}
                        fieldName={"EWResponse"}
                        onChange={_onChange}
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem>
                      <IonLabel position="stacked">Notes</IonLabel>
                      <IonTextarea
                        id="EWNotes"
                        name="EWNotes"
                        value={EWNotes}
                        onIonChange={_onChange}
                      />
                    </IonItem>
                  </>
                )}

                <Spacer size="30" />
              </IonList>
            </>
          )}
          {page === 7 && (
            <>
              <IonTitle>Morning Waking</IonTitle>
              <IonList>
                <IonItem>
                  <IonLabel position="stacked">
                    What time did your child wake to start the day?
                  </IonLabel>
                  <Spacer size="10" />
                  <IonNote>(i.e., they did not go back to sleep)</IonNote>
                  <Spacer size="10" />
                  {/* <IonDatetime
								id="MWTime"
								display-format="h:mm A"
								picker-format="h:mm A"
								name="MWTime"
								value={MWTime}
								onIonChange={_onChange}
							></IonDatetime> */}
                  <IonInput
                    name="MWTime"
                    value={MWTime}
                    type="time"
                    // hidden
                    onIonChange={_onChange}
                  />
                </IonItem>
                <Spacer size="30" />
                <IonItem>
                  <IonLabel position="stacked">
                    Any additional notes on this night's diary entry
                  </IonLabel>
                  <IonTextarea
                    id="additionalNotes"
                    name="additionalNotes"
                    value={additionalNotes}
                    onIonChange={_onChange}
                    autoGrow={true}
                  />
                </IonItem>
              </IonList>
            </>
          )}
          <Spacer size="60" />
          <EntryErrors errors={formErrors} />
          <FormNavigation
            page={page}
            setPage={changePage}
            onSubmit={_onSubmit}
            numPages={8}
          />
        </>
      )}
    </>
  );
};

export default AddEditEntrySleep;
